/**
 * 404 Not Foundページのコンポーネント
 * @returns {JSX.Element} 404 Not FoundページのJSX要素
 */
export function NotFound(): JSX.Element {
  return (
    <div>
      <h1>404 - Not Found</h1>
    </div>
  );
}
